import { IPaymentErrors } from 'features/payment/types';

import { t } from 'state/intl/translations';
import { TranslationKey } from 'state/intl/types';

export interface GetErrorMessageOptions {
  errors: IPaymentErrors;
}

export const getErrorMessage = ({ errors }: GetErrorMessageOptions): string | null => {
  const numberOfErrors = Object.values(errors).filter(Boolean).length;

  if (!numberOfErrors) {
    return null;
  }

  const id = numberOfErrors === 1 ? 'thereIsAnErrorInThisForm' : 'thereAreErrorsInThisForm';
  return t(id as TranslationKey, { numberOfErrors });
};
